import $store from '@/store/index'
import BotApi from '@/util/botapi'
import Api from '@/util/api'
import Data from '@/util/data'
import Util from '@/util/util'

export default {
  GetActiveBotList () {
    // console.log('GetActiveBotList', $store.state.sys.tradeExchange.Id)
    const botdata = $store.state.bots
    return BotApi.get('bot/list', {
      params: {
        token: $store.state.sys.token,
        etid: $store.state.sys.tradeExchange.Id,
        status: 'act',
        symbol: $store.state.bots.symbol
      }
    }).then(function (response) {
      // console.log(JSON.stringify(response.data))
      if (response.data !== null) {
        if (!response.data.err) {
          // ok
          if (response.data) {
            botdata.activeBotsList = response.data
          } else {
            botdata.activeBotsList = []
          }
        } else {
          // error
          Data.vm.$Notice.error({
            title: Data.vm.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(response.data.err),
            duration: 10
          })
        }
      } else {
        botdata.activeBotsList = []
      }
    }).catch(function (error) {
      // error
      console.log(error)
      Data.vm.$Notice.error({
        title: Data.vm.$text.tr('Ошибка'),
        desc: Util.returnTextForErr(error),
        duration: 10
      })
    })
  },
  CancelBot (botID, line) {
    const ref = this
    BotApi.get('bot/stop', {
      params: {
        token: $store.state.sys.token,
        id: botID
      }
    }).then(function (response) {
      // console.log('bot/stop', botID, response.data)
      if (response.data !== null) {
        if (!response.data.err) {
          // ok
          // ref.getBotList()
          line.remove()
          $store.state.bots.botsUpdated = Date.now()
          ref.UpdateBotBalance()
          Data.vm.$Message.success({
            content: Data.vm.$text.tr('Бот выключен'),
            duration: 5
          })
        } else {
          // error
          Data.vm.$Notice.error({
            title: Data.vm.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(response.data.err),
            duration: 10
          })
        }
      }
    }).catch(function (error) {
      // error
      console.log(error)
      Data.vm.$Notice.error({
        title: Data.vm.$text.tr('Ошибка'),
        desc: Util.returnTextForErr(error),
        duration: 10
      })
    })
  },
  UpdateBotBalance () {
    if (!$store.state.sys.tradeExchange.Id) {
      return
    }
    return Api
      .get('asset/balance?token=' + $store.state.sys.token + '&etid=' + $store.state.sys.tradeExchange.Id + '&symbol=' +
          $store.state.bots.symbol
      )
      .then(response => {
        $store.state.bots.lastPrice = response.data.LastPrice
        $store.state.bots.freeBal = response.data.QAssetFree
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  SelectBotSymbol (symbol) {
    if (!$store.state.bots.exchSymbol) {
      $store.state.bots.exchSymbol = {}
    }
    $store.state.bots.exchSymbol[$store.state.sys.tradeExchange.Id] = symbol

    // localStorage.setItem('capico_app_botSymbol', symbol)
    localStorage.setItem('capico_app_botExchSymbol', JSON.stringify($store.state.bots.exchSymbol))
    $store.state.bots.symbol = symbol
  },
  SaveBot () {
    const botdata = $store.state.bots
    const assets = $store.state.bots.symbol.split('_')
    let relaun = '0'
    if (botdata.autoLaunch) {
      relaun = '1'
    }
    let trig = botdata.triggerPrice
    if (!botdata.trigger) {
      trig = ''
    }
    let sl = botdata.slPrice
    if (!botdata.stopLoss) {
      sl = ''
    }

    const params = {
      token: $store.state.sys.token,
      id: botdata.editBot.Id,
      etid: $store.state.sys.tradeExchange.Id,
      symbol: assets[0] + '_' + assets[1],
      name: botdata.botName,
      amount: botdata.amount.toString(),
      buyPrice: botdata.buyPrice,
      sellPrice: botdata.sellPrice,
      trigger: trig,
      stopLoss: sl,
      relaunch: relaun,
      accumulate: botdata.accumulateType
    }
    if (botdata.slTimeoutEnabled) {
      params.slTimeout = botdata.slTimeout
    }
    return BotApi.get('bot/edit', {
      params
    })
  },
  SaveViewModeBot (bot) {
    // console.log('bot.Relaunch', bot.Relaunch)
    let relaun = '0'
    if (bot.Relaunch) {
      relaun = '1'
    }
    let trig = bot.Trigger
    if (trig === '0') {
      trig = ''
    }
    let sl = bot.StopLoss
    if (sl === '0') {
      sl = ''
    }

    const params = {
      token: $store.state.sys.token,
      id: bot.Id,
      etid: $store.state.sys.tradeExchange.Id,
      symbol: bot.Symbol,
      name: bot.Name,
      amount: bot.Amount,
      buyPrice: bot.BuyPrice,
      sellPrice: bot.SellPrice,
      trigger: trig,
      stopLoss: sl,
      relaunch: relaun,
      accumulate: bot.Accumulate
    }
    if (bot.SlTimeout > 0) {
      params.slTimeout = bot.SlTimeout
    }
    return BotApi.get('bot/edit', {
      params
    })
  }
}
